import { gql, TypedDocumentNode } from '@apollo/client'

import { DomainViewabilityToolsDTO } from '../types/domainViewabilityToolsDTO'

export const DOMAIN_VIEWABILITY_TOOL_FRAGMENT: TypedDocumentNode<DomainViewabilityToolsDTO> = gql`
  fragment DomainViewabilityToolFragment on DomainViewabilityTool {
    adHoldingEnabled
    createdAt
    creativeCodeKeywords
    distanceFromPageHeaderDesktop
    distanceFromPageHeaderMobile
    domainId
    excludeCreativeTypesEnabled
    extraSpaceBelowAdDesktop
    extraSpaceBelowAdMobile
    gamAdRenderMargin
    gamAdRequestMargin
    id
    kvTargetingAndPrebidAuction
    lazyLoadingEnabled
    lazyLoadTargetingPrebidAuctionEnabled
    lazyLoadType
    mobileScaling
    scrollSlowingEnabled
    scrollSlowingIntensity
    trafficAffected
    updatedAt
    viewabilityToolsEnabled
  }
`
